import { useMutation } from '@apollo/client';

import { startGameOrderMutation } from '../lib/order/startGameOrder/start-game-order-mutation';

// Same startOrderV2 mutation the classic game-purchase flow uses
// (src/pages/StartGameOrder/helpers/use-start-game-order), but without its
// redirect-to-/checkout/:orderId side effect - callers that render their own
// payment UI in place (like Supercharger/PaymentHostedFields) just need the orderId
// back to pass into useCompleteOrder.
export function useStartOrder({ userId, timeZone }) {
  const [mutate] = useMutation(startGameOrderMutation);

  const startOrder = async ({ gameId, gameType = 'falkor' }) => {
    const { data } = await mutate({
      variables: {
        items: [{ Game: { gameId, gameType } }],
        timeZone,
        userId,
      },
    });

    return data?.startOrder;
  };

  return { startOrder };
}
